/** Largura fixa e quebra de linha da coluna Cliente (listagem de contratos e campanhas). */
export const CONTRACT_CLIENT_COLUMN_CLASS = 'contract-client-column';

export const CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS = 'campaign-eligible-contracts-table';

export const contractClientColumnCss = `
  .ui.table td.${CONTRACT_CLIENT_COLUMN_CLASS},
  .ui.table th.${CONTRACT_CLIENT_COLUMN_CLASS} {
    width: 280px !important;
    max-width: 280px !important;
    min-width: 280px !important;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal !important;
    vertical-align: top;
  }
  .${CONTRACT_CLIENT_COLUMN_CLASS} .contract-client-name {
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    line-height: 1.35;
  }
  .${CONTRACT_CLIENT_COLUMN_CLASS} .contract-client-subtitle {
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }
`;

/** Layout da tabela de contratos elegíveis (Performance Seller / Team Leader). */
export const campaignEligibleContractsTableCss = `
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} {
    width: 100%;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .campaign-eligible-contracts-scroll {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table {
    table-layout: fixed !important;
    width: 100% !important;
    min-width: 720px;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS}.with-consultant .ui.table {
    min-width: 960px;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table col.col-client { width: 30%; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS}.with-consultant .ui.table col.col-client { width: 22%; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table col.col-linhas { width: 9%; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table col.col-tipo { width: 11%; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table col.col-valor { width: 13%; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table col.col-data { width: 10%; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table col.col-consultant { width: 18%; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table col.col-status { width: 15%; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table col.col-pontos { width: 8%; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table td,
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table th {
    vertical-align: top;
    box-sizing: border-box;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table td.${CONTRACT_CLIENT_COLUMN_CLASS},
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table th.${CONTRACT_CLIENT_COLUMN_CLASS} {
    width: auto !important;
    max-width: none !important;
    min-width: 160px !important;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal !important;
    overflow: visible;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table td:not(.${CONTRACT_CLIENT_COLUMN_CLASS}),
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table th:not(.${CONTRACT_CLIENT_COLUMN_CLASS}) {
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: anywhere;
    overflow: visible;
    text-overflow: clip;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .col-linhas { min-width: 96px; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .col-tipo { min-width: 108px; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .col-valor { min-width: 128px; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .col-data { min-width: 104px; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .col-consultant { min-width: 160px; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .col-status { min-width: 140px; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .col-pontos { min-width: 80px; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS}:not(.with-consultant) .col-client { min-width: 200px; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS}.with-consultant .col-client { min-width: 180px; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.label {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    vertical-align: middle;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .ui.table td:not(.${CONTRACT_CLIENT_COLUMN_CLASS}) .ui.label {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    overflow: visible;
    text-overflow: clip;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .col-status .status-cell-inner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    max-width: 100%;
    overflow: visible;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .col-status .status-cell-inner .ui.label {
    flex: 1 1 auto;
    min-width: 0;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .campaign-consultant-cell {
    max-width: 100%;
    overflow: visible;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .campaign-consultant-name,
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .campaign-consultant-email,
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .campaign-consultant-role {
    display: block;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    overflow: visible;
    text-overflow: clip;
    max-width: 100%;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .campaign-consultant-email {
    font-size: 0.85em;
    color: #666;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .campaign-consultant-role {
    font-size: 0.8em;
    color: #666;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS}.without-pontos .ui.table col.col-status { width: 18%; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS}.without-pontos:not(.with-consultant) .ui.table col.col-client { width: 34%; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS}.without-pontos.with-consultant .ui.table col.col-client { width: 26%; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS}.without-pontos .col-status { min-width: 160px; }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .campaign-table-filter-row th {
    padding: 6px 8px !important;
    background: rgba(255, 255, 255, 0.4) !important;
    overflow: visible !important;
    white-space: normal !important;
    font-weight: normal !important;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .campaign-table-filter-row .ui.input,
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .campaign-table-filter-row .ui.dropdown {
    width: 100%;
    min-width: 0;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .campaign-table-filter-row .ui.input input {
    font-size: 0.85rem;
    padding: 0.45em 0.55em;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .campaign-table-filter-date-stack {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .campaign-table-filter-actions {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: stretch;
  }
  @media (max-width: 900px) {
    .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS} .contract-cell-hide-md {
      display: none !important;
    }
  }
  @media (max-width: 1100px) {
    .${CAMPAIGN_ELIGIBLE_CONTRACTS_TABLE_CLASS}.with-consultant .contract-cell-hide-sm {
      display: none !important;
    }
  }
`;

/** Filtros inline no cabeçalho (modal de contratos de campanha). */
export const CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS = 'campaign-modal-contracts-table';

export const campaignModalContractsTableCss = `
  .campaign-modal-contracts-scroll {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} {
    table-layout: auto !important;
    width: max-content !important;
    min-width: 100%;
  }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-client { min-width: 200px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-cnpj { min-width: 140px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-status { min-width: 150px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-data-venda { min-width: 110px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-reneg { min-width: 72px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-reneg-valor { min-width: 100px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-acessos { min-width: 88px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-acessos-valor { min-width: 108px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-tipo { min-width: 100px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-consultor { min-width: 140px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-pontos { min-width: 80px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-bonif-linhas { min-width: 168px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-bonif-contrato { min-width: 140px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-time { min-width: 110px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-gerente { min-width: 120px; }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} thead tr:not(.campaign-table-filter-row) th {
    vertical-align: bottom;
    box-sizing: border-box;
    white-space: nowrap !important;
    overflow: visible !important;
    text-overflow: clip !important;
    max-width: none !important;
  }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} tbody td {
    vertical-align: top;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} tbody td.col-client {
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: anywhere;
    overflow: visible;
  }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-status .campaign-status-cell {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-status .campaign-status-cell .ui.label {
    flex: 1 1 auto;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
  }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .col-status .campaign-status-cell > *:last-child {
    flex: 0 0 auto;
  }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .campaign-consultor-cell {
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .campaign-consultor-name,
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .campaign-consultor-email {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .campaign-consultor-email {
    font-size: 0.85em;
    color: #666;
  }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} .ui.label {
    max-width: 100%;
    vertical-align: middle;
  }
  .${CAMPAIGN_MODAL_CONTRACTS_TABLE_CLASS} tbody td .ui.label.circular {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }
`;

export const campaignModalTableFilterRowCss = `
  .ui.table tr.campaign-table-filter-row th {
    padding: 6px 8px !important;
    background: rgba(245, 245, 245, 0.85) !important;
    overflow: visible !important;
    white-space: normal !important;
    font-weight: normal !important;
  }
  .ui.table tr.campaign-table-filter-row .ui.input,
  .ui.table tr.campaign-table-filter-row .ui.dropdown {
    width: 100%;
    min-width: 0;
  }
  .ui.table tr.campaign-table-filter-row .ui.input input {
    font-size: 0.85rem;
    padding: 0.45em 0.55em;
  }
  .ui.table tr.campaign-table-filter-row .campaign-table-filter-date-stack {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .ui.table tr.campaign-table-filter-row .campaign-table-filter-actions {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: stretch;
  }
`;
